import { defineMessages } from '../define';

export const choir = defineMessages(
  {
    'choir.title': 'Kórinn',
    'choir.search': 'Leita að félaga',
    'choir.search_clear': 'Hreinsa leit',
    'choir.total': { one: '{count} félagi', other: '{count} félagar' },
    'choir.group_count': { one: '{count} félagi', other: '{count} félagar' },
    'choir.group_other': 'Aðrir',
    'choir.on_leave': 'Í leyfi',
    'choir.invited': 'Ekki enn skráður inn',
    'choir.you': 'Þú',
    'choir.no_results': 'Enginn fannst',
    'choir.no_results_hint': 'Prófaðu annað nafn – kommur skipta ekki máli.',
    'choir.empty': 'Engir félagar enn',
    'choir.member': 'Félagi',
    'choir.not_found': 'Félaginn fannst ekki',
    'choir.not_found_hint': 'Hann gæti hafa verið tekinn úr félagatalinu.',
    'choir.call': 'Hringja',
    'choir.sms': 'SMS',
    'choir.email': 'Senda tölvupóst',
    'choir.add_contact': 'Bæta í tengiliði',
    'choir.phone': 'Sími',
    'choir.email_label': 'Netfang',
    'choir.no_contact': 'Hefur ekki valið að sýna símanúmer eða netfang.',
    'choir.edit_admin': 'Breyta í stjórnun',
    'choir.edit_profile': 'Breyta prófílnum mínum',
    'choir.vcard_note': 'Karlakór Grafarvogs – {section}',
    'choir.vcard_failed': 'Ekki tókst að búa til tengilið.',
  },
  {
    'choir.title': 'Choir',
    'choir.search': 'Search for a member',
    'choir.search_clear': 'Clear search',
    'choir.total': { one: '{count} member', other: '{count} members' },
    'choir.group_count': { one: '{count} member', other: '{count} members' },
    'choir.group_other': 'Others',
    'choir.on_leave': 'On leave',
    'choir.invited': 'Not signed in yet',
    'choir.you': 'You',
    'choir.no_results': 'Nobody found',
    'choir.no_results_hint': 'Try another name – accents do not matter.',
    'choir.empty': 'No members yet',
    'choir.member': 'Member',
    'choir.not_found': 'Member not found',
    'choir.not_found_hint': 'They may have been removed from the directory.',
    'choir.call': 'Call',
    'choir.sms': 'Text',
    'choir.email': 'Send e-mail',
    'choir.add_contact': 'Add to contacts',
    'choir.phone': 'Phone',
    'choir.email_label': 'E-mail',
    'choir.no_contact': 'Has not chosen to show a phone number or e-mail.',
    'choir.edit_admin': 'Edit in admin',
    'choir.edit_profile': 'Edit my profile',
    'choir.vcard_note': 'Karlakór Grafarvogs – {section}',
    'choir.vcard_failed': 'Could not create the contact.',
  },
);
